import type { MaterialSrc } from "common/materials/materialSrc";
import type { Face } from "geom/brep";
import type { Mesh3 } from "geom/mesh";
import type { FaceCategory } from "./faceCategories";

export enum FaceDiffType {
  ADDED = "ADDED",
  REMOVED = "REMOVED",
  STATIC = "STATIC",
}

export type FaceHashMap = { [hash: number]: HashedFaceInfo };
export interface HashedFaceInfo {
  readonly face?: Face;
  readonly mesh?: Mesh3;
  readonly count: number;
  readonly entityIds: string[];
  readonly materialSrc?: MaterialSrc;
}

export interface FaceHashOptions {
  readonly includeMaterialSrc?: boolean;
  readonly includeFaceTags?: boolean;
}

export type FaceHashOperation = "ADD" | "SUBTRACT";

export type FaceHashRenderTypeKey = "renderLines" | "renderMeshes" | "renderMeshMaterials" | "renderMeshOpacity";

export type FaceHashRenderSettings = {
  [K in FaceHashRenderTypeKey]?: boolean;
};

export type FaceDiffTypeSettings = {
  [K in FaceDiffType]?: FaceHashRenderSettings;
};

export interface BuildingEntityFaceHashMapsRenderSettings {
  /**
   * Used in the even that the session is generating a face hash map
   * locally as opposed to using the debugFaceDiff object which is imported from
   * a test failure output
   */
  faceHashGenerationMode: "WEB" | "EXPORT";
  /**
   * The set of face categories that are used to generate the face hash map
   */
  faceDiffEntityMask: Set<FaceCategory>;
  /**
   * Per type settings for render visualisation
   */
  faceDiffTypeSettings: FaceDiffTypeSettings;
}
